import { request } from '@/services/request/request.api'

import {
	IColor,
	ICreateColorParams,
	ICreateFolderParams,
	ICreateShareLinkParams,
	ICreateShareLinkResponse,
	IDeleteFolder,
	IGetColorsResponse,
	IGetFoldersListResponse,
	IHighlightsFolder,
	IImportSharedHighlightsParams,
	IImportSharedHighlightsResponse,
	ISegment,
	ISharedHighlightsResponse,
	IUpdateFolderParams,
	TAddHighlightResponse
} from '@/types/highlight.interface'

export const HighlightsService = {
	async getColors() {
		return request<IGetColorsResponse>({
			url: '/colors',
			method: 'GET'
		})
	},
	async createColor({ name, code }: ICreateColorParams) {
		return request<IColor>({
			url: '/colors',
			method: 'POST',
			data: {
				name,
				code
			}
		})
	},
	async getFoldersList(taskId: string) {
		return request<IGetFoldersListResponse>({
			url: '/highlights/db',
			method: 'GET',
			params: {
				task_id: taskId
			}
		})
	},
	async getFolder(highlightId: number) {
		return request<IHighlightsFolder>({
			url: `/highlights/db/${highlightId}`,
			method: 'GET'
		})
	},
	async createFolder({
		name,
		taskId,
		colorId,
		description,
		segments = []
	}: ICreateFolderParams) {
		return request<IHighlightsFolder>({
			url: '/highlights/db',
			method: 'POST',
			data: {
				name,
				task_id: taskId,
				color_id: colorId,
				description,
				segments
			}
		})
	},
	async updateFolder(
		highlightId: number,
		{ name, colorId, description }: IUpdateFolderParams
	) {
		return request<IHighlightsFolder>({
			url: `/highlights/db/${highlightId}`,
			method: 'PATCH',
			data: {
				name,
				color_id: colorId,
				description
			}
		})
	},
	async deleteFolder(highlightId: number) {
		return request<IDeleteFolder>({
			url: `/highlights/db/${highlightId}`,
			method: 'DELETE'
		})
	},
	async addHighlight({
		highlightId,
		segment
	}: {
		highlightId: number
		segment: ISegment
	}) {
		return request<TAddHighlightResponse>({
			url: `/highlights/db/${highlightId}/segments`,
			method: 'POST',
			data: segment
		})
	},
	async deleteHighlight({
		highlightId,
		index
	}: {
		highlightId: number
		index: number
	}) {
		return request<TAddHighlightResponse>({
			url: `/highlights/db/${highlightId}/segments/${index}`,
			method: 'DELETE'
		})
	},
	async createShareLink({
		highlightIds,
		expiresInHours = 24,
		maxUses = 1
	}: ICreateShareLinkParams) {
		return request<ICreateShareLinkResponse>({
			url: '/highlights/db/share-link',
			method: 'POST',
			data: {
				highlight_ids: highlightIds,
				expires_in_hours: expiresInHours,
				max_uses: maxUses
			}
		})
	},

	async getSharedHighlights(token: string) {
		return request<ISharedHighlightsResponse>({
			url: `/highlights/db/share-link/${token}`,
			method: 'GET'
		})
	},

	async importSharedHighlights({
		token,
		highlightIds
	}: IImportSharedHighlightsParams) {
		return request<IImportSharedHighlightsResponse>({
			url: '/highlights/db/import',
			method: 'POST',
			data: {
				token,
				...(highlightIds ? { highlight_ids: highlightIds } : {})
			}
		})
	}
}
